export const EVENT_TYPES = {
  SYNC_VUE_ROUTE: "sync_vue_route",
  SYNC_USER: "sync_user",
  SYNC_IS_IFRAME: "sync_is_iframe",
  SYNC_CUSTOMER: "sync_customer",
  OPEN_CUSTOMER_SELECT: "open_customer_select",
  OPEN_FEEDBACK: "open_feedback",
  /**
   * signifies that the user has confirmed a customer in React
   * and that Vue will have to run fetchCustomer using the
   * passed parameters in order to have its customer correctly set
   * in Vuex
   */
  REACT_INITIATED_CUSTOMER_UPDATE: "react_initiated_customer_update",
  REACT_INITIATED_CUSTOMER_CLEAR: "react_initiated_customer_clear",
};

export const triggerEvent = (eventType, detail) => {
  const { CustomEvent } = window;
  const event = new CustomEvent(eventType, { detail });
  window.dispatchEvent(event);
};
export const addEventListener = (eventType, callback) => {
  window.addEventListener(eventType, callback, true);
};
